export default "__VITE_ASSET__BIS3QeEK__"